// this file overrides the environment.ts file when the application is built for production. See "fileReplacements" in angular.json.
export const environment = {
  production: true,
  apiEndpoint: `${window.location.protocol}//${window.location.hostname}:5000`, // DO NOT APPEND A FORWARD SLASH!!! (api resource paths should prefix with a forward slash in method calls)
  version: '4.12.9',
  channel: 'Production'
};